type SectionHeadingProps = {
  kicker: string;
  title: string;
  desc?: string;
  id?: string;
};

export default function SectionHeading({ kicker, title, desc, id }: SectionHeadingProps) {
  return (
    <div id={id} className="max-w-2xl">
      <span className="inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-secondary-600">
        <span className="h-px w-6 bg-secondary-400" aria-hidden="true"></span>
        {kicker}
      </span>
      <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
        {title}
      </h2>
      {desc && <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}